import api from '@pray/shared/utils/api';
import type { PaginatedListResponse } from '@pray/shared/utils/api/types/response';

import type { AdminArtistResponse, ListAdminArtistsParams } from './types';

export async function listAdminArtists(params: ListAdminArtistsParams = {}) {
  const url = '/web/studio/admin/artists';

  const queryParams: Record<string, string | number | boolean> = {};

  if (params.query) queryParams.query = params.query;
  if (params.includeDestroyed) queryParams.include_destroyed = true;
  if (params.limit !== undefined) queryParams.limit = params.limit;
  if (params.offset !== undefined) queryParams.offset = params.offset;

  const response = await api.executeGetRequest<PaginatedListResponse<AdminArtistResponse>>(url, queryParams);

  return response;
}
